import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { initCountdown } from '../global/countdown';
import manualModalOpen from '../sections/product/manualModalOpen';

const addBarElement = (barClasses, countdownClasses, block, barsContainer) => {
  const barElem = document.createElement('li');
  const {
    text,
    bgColor,
    textColor,
    displayCountdown,
    countdownYear,
    countdownMonth,
    countdownDay,
    countdownHour,
    countdownMinute,
    countdownSecond,
    sizeChartEnabled,
    linkUrl,
    linkNewTab
  } = block;

  barClasses.forEach(barClass => {
    barElem.classList.add(barClass);
  });

  if (sizeChartEnabled) {
    barElem.classList.add('trigger-size-guide');
    barElem.setAttribute('data-size-guide-trigger', 'true');
    barElem.style.cursor = 'pointer';
  }

  let contentContainer = barElem;

  barElem.style.backgroundColor = bgColor;
  barElem.style.color = textColor;

  if (linkUrl && !sizeChartEnabled) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    const links = tempDiv.querySelectorAll('a');
    links.forEach(link => {
      const textNode = document.createTextNode(link.textContent || link.innerText);
      link.parentNode.replaceChild(textNode, link);
    });
    const cleanedText = tempDiv.innerHTML;

    const linkElem = document.createElement('a');
    linkElem.href = linkUrl;
    linkElem.classList.add('announcement-link');
    linkElem.innerHTML = cleanedText;
    linkElem.style.display = 'flex';
    linkElem.style.flexDirection = 'row';
    linkElem.style.alignItems = 'center';
    linkElem.style.justifyContent = 'center';
    linkElem.style.width = '100%';
    linkElem.style.height = '100%';
    linkElem.style.color = textColor;
    linkElem.style.textDecoration = 'none';

    if (linkNewTab) {
      linkElem.target = '_blank';
      linkElem.rel = 'noopener';
    }

    barElem.append(linkElem);
    contentContainer = linkElem;
  } else {
    barElem.innerHTML = text;
  }

  if (displayCountdown) {
    const countdownElem = document.createElement('div');

    countdownClasses.forEach(countdownClass => {
      countdownElem.classList.add(countdownClass);
    });

    const dateStr = `${countdownMonth} ${countdownDay}, ${countdownYear} ${countdownHour}:${countdownMinute}:${countdownSecond}`;
    const date = new Date(dateStr).getTime();

    initCountdown(date, countdownElem);

    contentContainer.append(countdownElem);
  }

  barsContainer.append(barElem);
};

const announcementsInit = () => {
  const announcementSections = document.querySelectorAll('[data-announcements]');

  if (!announcementSections) return false;

  announcementSections.forEach(section => {
    const blocks = JSON.parse(section.dataset.announcements);
    const barClasses = section.dataset.barClasses.split(', ');
    const countdownClasses = section.dataset.countdownClasses.split(', ');

    const applicableBlocks = blocks.filter(settings => {
      const countries = settings.countryList.split(',').map(country => country.trim());
      return countries.includes(window.blubolt.geo.handle) || settings.global;
    });

    const announcementSwiper = section.querySelector('[data-announcement-swiper]');
    const announcementSlides = section.querySelector('[data-announcement-slides]');

    if (applicableBlocks.length > 0) {
      applicableBlocks.forEach(block => {
        addBarElement(barClasses, countdownClasses, block, announcementSlides);
      });

      const autoplayAttr = section.dataset.autoplayEnabled;
      const autoplayEnabled = autoplayAttr === 'true';

      const autoplayDelaySeconds = parseInt(section.dataset.autoplayDelay || '10', 10);
      const autoplayDelayMs = Number.isNaN(autoplayDelaySeconds) ? 10000 : autoplayDelaySeconds * 1000;

      const swiperConfig = {
        speed: 250,
        modules: [Autoplay]
      };

      if (applicableBlocks.length > 1) {
        swiperConfig.loop = true;

        if (autoplayEnabled) {
          swiperConfig.autoplay = {
            delay: autoplayDelayMs,
            disableOnInteraction: false
          };
        }
      }

      new Swiper(announcementSwiper, swiperConfig);

      manualModalOpen();
    }
  });
};
export default announcementsInit;
